import React, { useState } from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  Snackbar,
} from "@mui/material";
import { GameSelector } from "../../General/GameSelector";
import { useSchedule } from "../../../contexts/ScheduleContext";
import { useLogger } from "../../../contexts/LoggerContext";

interface Props {
  showResetGameLog: boolean;
  handleClose: () => void;
}

export const ResetGameLogs = ({ showResetGameLog, handleClose }: Props) => {
  const { games, isLoading, error } = useSchedule();
  const { gameLog, setSelectedGame, deleteGameLog } = useLogger();
  const [notification, setNotification] = useState<{
    message: string;
    type: "success" | "error";
  } | null>(null);

  const handleCloseNotification = () => {
    setNotification(null);
  };

  return (
    <>
      <Dialog
        open={showResetGameLog}
        onClose={handleClose}
        fullWidth
        sx={{ minHeight: 700 }}
      >
        <DialogTitle>Reset Game Logs</DialogTitle>
        <DialogContent>
          <GameSelector games={games} onGameSelected={setSelectedGame} />
          {gameLog && (
            <div>
              <h3>Game Logs</h3>
              <p>There are {gameLog.logs.length} logs for this game.</p>
            </div>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              deleteGameLog();
              setNotification({ message: "Game log deleted", type: "success" });
              handleClose();
            }}
          >
            Delete Game Log
          </Button>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={!!notification}
        autoHideDuration={5000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification?.type || "info"}
          variant="filled"
          sx={{ width: "100%", display: notification ? "flex" : "none" }}
        >
          {notification?.message || ""}
        </Alert>
      </Snackbar>
    </>
  );
};
